import React from 'react';
import ChatMessage from '../../chat/ChatMessage';
import Card from '../../common/Card';

/**
 * The AI-written overall summary of a student's report.
 */
export default function StudentReportSummaryCard({ summary }) {
    if (!summary || !String(summary).trim()) return null;

    return (
        <Card title="Overall summary">
            <ChatMessage
                message={{
                    id: 'student-overall-summary',
                    content: String(summary),
                    role: 'assistant'
                }}
                fullWidth
                isPlain
                showPdfExport={false}
            />
        </Card>
    );
}
